import { configureStore } from '@reduxjs/toolkit';
import authSlice from './reducers/AuthSlice';
import clientsSlice from './reducers/ClientsSlice';
import countriesSlice from './reducers/CountriesSlice';
import categoryTypesSlice from './reducers/CategoryTypesSlice';
import categoriesSlice from './reducers/CategoriesSlice';
import servicesSlice from './reducers/ServicesSlice';
import clientContactsSlice from './reducers/ClientContactsSlice';
import vendorsSlice from './reducers/VendorsSlice';
import vendorContactsSlice from './reducers/VendorContactsSlice';
import usersSlice from './reducers/UsersSlice';
import offlineReasonsSlice from './reducers/OfflineReasonsSlice';
import extensionsSlice from './reducers/ExtensionsSlice';
import orderComponentsSlice from './reducers/OrderComponents';
import inquiriesSlice from './reducers/InquiriesSlice';
import ordersSlice from './reducers/OrdersSlice';
import contactsSlice from './reducers/ContactsSlice';
import emailsSlice from './reducers/EmailsSlice';
import SMSSenders from './reducers/SMSSendersSlice';
import InsuranceRatesSlice from './reducers/InsuranceRatesSlice';
import CheckerSlice from './reducers/CheckerSlice';
import SettingsSlice from './reducers/SettingsSlice';
import AdvertisingSettingsSlice from './reducers/AdvertisingSettingsSlice';
import SystemSettingsSlice from './reducers/SystemSettingsSlice';
import ResultsSlice from './reducers/ResultsSlice';
import InfoSlice from './reducers/InfoSlice';
import DlogsSlice from './reducers/DlogSlice';
import LoadingsSlice from './reducers/LoadingsSlice';
import performanceIndicatorsSlice from './reducers/PerformanceIndicatorsSlice';
import lockedRecommendationsSlice from './reducers/LockedRecommendationsSlice';
import invoiceHistorySlice from './reducers/InvoiceHistorySlice';

const rootReducer = {
    auth: authSlice,
    clients: clientsSlice,
    countries: countriesSlice,
    categoryTypes: categoryTypesSlice,
    categories: categoriesSlice,
    services: servicesSlice,
    clientContacts: clientContactsSlice,
    vendors: vendorsSlice,
    vendorContacts: vendorContactsSlice,
    users: usersSlice,
    offlineReasons: offlineReasonsSlice,
    extensions: extensionsSlice,
    orderComponents: orderComponentsSlice,
    inquiries: inquiriesSlice,
    orders: ordersSlice,
    contacts: contactsSlice,
    emails: emailsSlice,
    SMSSenders: SMSSenders,
    insuranceRates: InsuranceRatesSlice,
    checker: CheckerSlice,
    settings: SettingsSlice,
    advertisingSettings: AdvertisingSettingsSlice,
    systemSettings: SystemSettingsSlice,
    results: ResultsSlice,
    info: InfoSlice,
    dlogs: DlogsSlice,
    loadings: LoadingsSlice,
    performanceIndicators: performanceIndicatorsSlice,
    lockedRecommendations: lockedRecommendationsSlice,
    invoiceHistory: invoiceHistorySlice
};

const store = configureStore({
    reducer: rootReducer,
});

export default store;
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
